import { configureStore } from '@reduxjs/toolkit';
import { longTermHousingRentalsReducer } from './slices/longTermHousingRentals.slice';

export const store = configureStore({
  reducer: {
    longTermHousingRentals: longTermHousingRentalsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
